import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const ResponseBasicInfoComponent = ({
    selectedResponse, handleInnerFormChange, post,libraryData
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        

                         <InputContainer
                            label="Chapter Post"
                            labelField="Text"
                            list={post}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ChapterPostId'
                                )
                            }}
                            optionName='Choose Post'
                            type="select"
                            value={selectedResponse?.ChapterPostId}
                            valueField="Id"
                        /> 
                            

                          <InputContainer
                            label="Content"
                            name="Content"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Content'
                                );
                            }}
                            type="text"
                            value={selectedResponse?.Content}
                        />

                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}

export default ResponseBasicInfoComponent;
